import { __decorate, __extends } from "tslib";
import { CustomElement, FoundationProperty, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { RippleAdapter } from './ripple-adapter';
import { RIPPLE_CONSTANTS } from './ripple-constants';
import { RippleFoundation } from './ripple-foundation';
var RippleComponent = /** @class */ (function (_super) {
    __extends(RippleComponent, _super);
    function RippleComponent() {
        var _this = _super.call(this) || this;
        _this._foundation = new RippleFoundation(new RippleAdapter(_this));
        return _this;
    }
    Object.defineProperty(RippleComponent, "observedAttributes", {
        get: function () {
            return [
                RIPPLE_CONSTANTS.attributes.TARGET,
                RIPPLE_CONSTANTS.attributes.UNBOUNDED
            ];
        },
        enumerable: true,
        configurable: true
    });
    RippleComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'target');
        upgradeProperty(this, 'unbounded');
    };
    RippleComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    RippleComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    RippleComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case RIPPLE_CONSTANTS.attributes.TARGET:
                this.target = newValue;
                break;
            case RIPPLE_CONSTANTS.attributes.UNBOUNDED:
                this.unbounded = coerceBoolean(newValue);
                break;
        }
    };
    RippleComponent.prototype.layout = function () {
        this._foundation.layout();
    };
    __decorate([
        FoundationProperty()
    ], RippleComponent.prototype, "target", void 0);
    __decorate([
        FoundationProperty()
    ], RippleComponent.prototype, "unbounded", void 0);
    RippleComponent = __decorate([
        CustomElement({
            name: RIPPLE_CONSTANTS.elementName
        })
    ], RippleComponent);
    return RippleComponent;
}(HTMLElement));
export { RippleComponent };
